import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { withRouter } from "react-router-dom";

import { Center, ImageSection, LogeButton, Icon, Black, ModalHeading } from './GeneralStyle'

import headerImage from '../images/modal/tl_header_bewerbung.jpg';
import successIcon from '../images/icons/tl_check_bewerbung.png'

class ContactSuccessModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: this.props.showModal,
      firstname: null,
      lastname: null
    }
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  closeModal = () => {
    this.setState({ 
      showModal: false,
      firstname: null,
      lastname: null
     })
  }

  openModal = (firstname, lastname) => {
    this.setState({ 
      showModal: true,
      firstname: firstname,
      lastname: lastname
    })
  }

  render() {
    return (
      <Modal show={this.state.showModal} onHide={this.closeModal}>
        <ImageSection background={headerImage}>
          <Modal.Header closeButton>
            <Modal.Title>
              <div><ModalHeading>Vielen Dank, {this.state.firstname} {this.state.lastname}!</ModalHeading></div>
            </Modal.Title>
          </Modal.Header>
        </ImageSection>
        <Modal.Body>
          <Center marginTop={30} marginBottom={30}>
            <Icon icon={successIcon} size={168} margin={0} float={"none"} />
          </Center>
          <Center marginTop={40} marginBottom={30}>
            <Black>Wir werden uns so rasch wie möglich um ihr Anliegen kümmern und Ihnen Rückmeldung erteilen!</Black>
          </Center>
          <Center marginTop={70} marginBottom={30}>
            <LogeButton
              hoverFontColor={"white"}
              onClick={() => { this.closeModal() }}>
              schließen</LogeButton>
          </Center>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withRouter(ContactSuccessModal)




// WEBPACK FOOTER //
// /src/components/ContactSuccessModal.js